<template>
  <div>
    <p>{{label}}</p>
    <div class="quantite-contener">
      <div class="touchspin">
        <span class="value">
          {{value}}
        </span>
        <span
          @click="$emit('subtract')"
          class="compteur-item"
        >
          -
        </span>
        <span
          @click="$emit('add')"
          class="compteur-item"
        >
          +
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addSubtractItem',
  props: {
    label: String,
    value: Number,
  },
}
</script>
